// export const server = `http://localhost:3005`;
// export const serverType = `dev`;

// prod
// export const server = `http://34.19.41.170:3000`;
export const server = `https://fullspectrumgroup.co`;
export const serverType = `prod`;

// staging
// export const server = `http://136.118.169.157:3000`;
// export const serverType = `staging`;
